import(/* webpackMode: "eager" */ "/home/ubuntu/download/69958902f782d500146627d7/classic24digital/src/app/homepage/page.tsx");
